module.exports = __webpack_public_path__ + "static/media/hide_solution_icon.4c47b769.png";